import React, { useEffect } from "react";
import ArticleList from "@Components/kindsum/ArticleList";
import { fetchArticleNav } from "@Services/kindsum";
import { IArticleNav, IKindsPcInfo } from "@Types/kindsum";
import { useSetState } from "ahooks";
import { useQuery } from "react-query";

const Tag: React.FC<any> = ({ press, onClick, name }) => {
  return (
    <div
      className={`${
        !press ? "bg-[#F5F5F5]" : "bg-[#3264FF] text-white"
      } px-10 h-24 rounded-4 flex justify-center items-center cursor-pointer`}
      id={"Tag"}
      onClick={onClick}
    >
      {name}
    </div>
  );
};

interface IKindSumCarList {
  setParams: any;
  consultRef: any;
  data: IKindsPcInfo;
}

const KindSumCarList: React.FC<IKindSumCarList> = ({ consultRef, setParams, data }) => {
  const { kindId, brandName, kindName } = data;
  const [query, setQuery] = useSetState({
    name: "",
  });
  const { name } = query;

  const { data: nav = [] } = useQuery<IArticleNav["items"]>([`fetchArticleNav`], async () => {
    // 传入limit由后端处理是否返回：最新、更多
    const res = await fetchArticleNav({ kindId, limit: 20 });
    !!res.data.items.length && setQuery({ name: res.data.items[0].contentType2Group });
    return res?.status === 12000 ? res.data.items || res.data : [];
  });

  if (!nav?.length) {
    return null;
  }

  return (
    <div id={"KindSumCarList"} className='text-black w-full mt-40'>
      <div className='flex justify-between items-center'>
        <div className='text-20 font-[600]'>{`${brandName} ${kindName} 精選資訊`}</div>
        <div className='flex gap-14 items-center text-14 text-[#666]'>
          {nav?.length > 0 &&
            nav
              .filter((_) => _.name !== "更多")
              .map((item: any, index: number) => (
                <Tag
                  press={name === item.contentType2Group}
                  onClick={() => {
                    setQuery({ name: item.contentType2Group });
                  }}
                  name={item.name}
                  key={index}
                />
              ))}
          {nav[nav.length - 1]?.name === "更多" && (
            <div
              id='Tag'
              className='text-16 cursor-pointer'
              onClick={() => {
                const $more = consultRef.current;
                scrollTo(0, $more.getBoundingClientRect().top + window.scrollY - 190);
              }}
            >
              更多
            </div>
          )}
        </div>
      </div>
      <ArticleList name={name} setParams={setParams} kindId={kindId} />
    </div>
  );
};

export default KindSumCarList;
